import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteNoteMutationVariables = Types.Exact<{
  input: Types.NoteInput;
}>;


export type DeleteNoteMutation = { deleteNote: { success?: boolean | null } };


export const DeleteNoteDocument = /*#__PURE__*/ gql`
    mutation deleteNote($input: NoteInput!) {
  deleteNote(input: $input) {
    success
  }
}
    `;

export function useDeleteNoteMutation() {
  return Urql.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument);
};